module.exports = __webpack_public_path__ + "e8ec0146c495d010253e1e6593992105.fbx";